'use strict';

var _ = require('lodash');
var FaresOptimizerAnalysisFiltersController = function FaresOptimizerAnalysisFiltersController($scope, filterConfigService) {
  $scope.screenState.filters = {};
  $scope.availableFilters = [];
  $scope.collapseFilter = function () {
    $scope.screenState.sideFilterExpanded = false;
  };
  $scope.setInitialFilterValues = function () {
    _.forEach($scope.availableFilters, function (filter) {
      $scope.screenState.filters[filter.filterId] = {};
      $scope.screenState.filters[filter.filterId].available = _.map(filter.options, 'value');
      if (filter.filterId !== 'status' || filter.filterId !== 'recommendationActionCodes' || filter.filterId !== 'minStaysList' || filter.filterId !== 'maxStayList') {
        $scope.screenState.filters[filter.filterId].selected = _.map(filter.options, 'value');
      } else {
        var selectedItems = _.map(filter.options, function (option) {
          return option.disableStatus === false ? option.value : undefined;
        });
        $scope.screenState.filters[filter.filterId].selected = _.remove(selectedItems, undefined);
      }
    });
    $scope.screenState.filters = _.cloneDeep($scope.screenState.filters);
  };
  $scope.updateFilterValues = function () {
    if ($scope.screenState.rawData.length > 0) {
      if (_.isNil($scope.screenState.reloadFilters) || $scope.screenState.reloadFilters) {
        $scope.availableFilters = filterConfigService.loadFiltersFromConfig($scope.screenState.rawData);
        $scope.setInitialFilterValues();
      }
      $scope.screenState.reloadFilters = false;
    }
  };
  $scope.$watchCollection('screenState.rawData', $scope.updateFilterValues);
};
FaresOptimizerAnalysisFiltersController.$inject = ['$scope', 'FaresOptimizerAnalysisFilterConfigurationService'];
module.exports = FaresOptimizerAnalysisFiltersController;